export default "__VITE_ASSET__BW9LASC4__"